import { useQuery } from '@apollo/client';
import { GET_CUSTOMER_PUBLIC } from '../graphql/queries/customer';

export const useCustomerPublic = () => {
  const { data: customerData, loading: customerLoading, error: customerError, refetch: refetchCustomer } = useQuery(GET_CUSTOMER_PUBLIC);

  return {
    customerData: customerData?.getCustomerPublic,
    loading: customerLoading,
    error: customerError,
    refetchCustomer,
  };
};
